import { GateDirection } from '@planning/app/api'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import { SvgIconProps } from '@mui/material'

interface Props extends SvgIconProps {
  direction?: GateDirection
}

export const GateDirectionIcon = ({ direction, ...iconProps }: Props) => {
  switch (direction) {
    case GateDirection.In:
      return <LoginIcon {...iconProps} />
    case GateDirection.Out:
      return <LogoutIcon {...iconProps} />
    case GateDirection.Both:
    default:
      return <SwapHorizIcon {...iconProps} />
  }
}
